jQuery(document).ready(function($) {
    $('.equipment-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.equipment-gallery-nav'
    });
    $('.equipment-gallery-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.equipment-gallery',
        dots: true,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: 0,
        arrows: false
    });
    $('.copy-to-clipboard').click(function() {
        var $temp = $('<input>');
        $('body').append($temp);
        $temp.val(window.location.href).select();
        document.execCommand('copy');
        $temp.remove();
        $(this).siblings('.copy-confirmation').fadeIn();
    });

    if ($('body').hasClass('page-template-sales-platform')) {
        var canBeLoaded = true;
        var page = parseInt(loadmoresalesequipment_params.current_page) + 1;
        var maxPage = loadmoresalesequipment_params.max_page;
        var currentFilter = 'All';

        $('#load-more-button').on('click', function() {
            if (!canBeLoaded || currentFilter !== 'All') {
                return;
            }
            loadMoreSalesItems(currentFilter, page);
        });

        $('#filter-load-more-button').on('click', function() {
            if (!canBeLoaded || currentFilter === 'All') {
                return;
            }
            loadMoreSalesItems(currentFilter, page);
        });

        $('.equipment-filters .category-filter').on('click', function() {
            $('.equipment-filters .category-filter').removeClass('active-filter');
            $(this).addClass('active-filter');
            currentFilter = $(this).data('filter');
            applySalesFilter(currentFilter);
        });

        function applySalesFilter(filterValue) {
            // console.log('Applying filter: ' + filterValue);
            $.ajax({
                url: loadmoresalesequipment_params.ajaxurl,
                type: 'POST',
                data: {
                    action: 'filter_sale_equipment',
                    filter: filterValue
                },
                beforeSend: function() {
                    // console.log('Before sending AJAX for filter');
                    canBeLoaded = false;
                    $('#load-more-container').empty();
                    $('#fetching').fadeIn();
                    $('#no-results').fadeOut();
                    $('#load-more-button').hide();
                    $('#filter-load-more-button').hide();
                },
                success: function(response) {
                    // console.log('Filter AJAX response:', response);
                    if (response.success) {
                        $('#fetching').fadeOut();
                        $('#load-more-container').html(response.data.content);
                        page = 2;
                        maxPage = response.data.max_page;
                        canBeLoaded = true;

                        if (filterValue === 'All') {
                            if (maxPage > 1) {
                                $('#load-more-button').text('Load More').show();
                                $('#filter-load-more-button').hide();
                            } else {
                                $('#load-more-button').hide();
                            }
                        } else {
                            if (maxPage > 1) {
                                $('#filter-load-more-button').text('Load More ' + filterValue).show();
                            } else {
                                $('#filter-load-more-button').hide();
                            }
                        }
                    } else {
                        $('#fetching').fadeOut();
                        $('#no-results').fadeIn();
                        canBeLoaded = false;
                        $('#filter-load-more-button').hide();
                        $('#load-more-button').hide();
                        // console.log('No results found for filter');
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX request failed');
                    console.log(textStatus, errorThrown);
                }
            });
        }


        function loadMoreSalesItems(filterValue, currentPage) {
            console.log('Loading more items. Filter: ' + filterValue + ', Page: ' + currentPage);
            $.ajax({
                url: loadmoresalesequipment_params.ajaxurl,
                type: 'POST',
                data: {
                    action: 'loadmoresalesequipment',
                    page: currentPage,
                    filter: filterValue
                },
                beforeSend: function() {
                    console.log('Before sending AJAX for load more');
                    console.log(filterValue);
                    canBeLoaded = false;
                    $('#load-more-button').text('Loading...');
                    $('#filter-load-more-button').text('Loading...');
                },
                success: function(response) {
                    console.log('Load More AJAX response:', response);
                    if (response.success) {
                        $('#load-more-container').append(response.data.content);
                        page++;
                        canBeLoaded = true;

                        if ( filterValue == 'All' ) {
                            if (page > response.data.max_page) {
                                $('#load-more-button').hide();
                            } else {
                                $('#load-more-button').text('Load More').show();
                            }
                        }
                        else {
                            if (page > response.data.max_page) {
                                $('#filter-load-more-button').hide();
                            } else {
                                $('#filter-load-more-button').text('Load More ' + filterValue).show();
                            }
                        }


                    } else {
                        $('#load-more-button').hide();
                        $('#filter-load-more-button').hide();
                        $('#no-results').fadeIn();
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX request failed');
                    console.log(textStatus, errorThrown);
                }
            });
        }

    }

    if ($('body').hasClass('page-template-hire-platform')) {
        var canBeLoaded = true;
        var page = parseInt(loadmorehireequipment_params.current_page) + 1;
        var maxPage = loadmorehireequipment_params.max_page;
        var currentFilter = 'All';

        $('#load-more-button').on('click', function() {
            if (!canBeLoaded || currentFilter !== 'All') {
                return;
            }
            loadMoreHireItems(currentFilter, page);
        });

        $('#filter-load-more-button').on('click', function() {
            if (!canBeLoaded || currentFilter === 'All') {
                return;
            }
            loadMoreHireItems(currentFilter, page);
        });

        $('.equipment-filters .category-filter').on('click', function() {
            $('.equipment-filters .category-filter').removeClass('active-filter');
            $(this).addClass('active-filter');
            currentFilter = $(this).data('filter');
            applyHireFilter(currentFilter);
        });

        function applyHireFilter(filterValue) {
            console.log('Applying filter: ' + filterValue);
            $.ajax({
                url: loadmorehireequipment_params.ajaxurl,
                type: 'POST',
                data: {
                    action: 'filter_hire_equipment',
                    filter: filterValue
                },
                beforeSend: function() {
                    // console.log('Before sending AJAX for filter');
                    canBeLoaded = false;
                    $('#load-more-container').empty();
                    $('#fetching').fadeIn();
                    $('#no-results').fadeOut();
                    $('#load-more-button').hide();
                    $('#filter-load-more-button').hide();
                },
                success: function(response) {
                    // console.log('Filter AJAX response:', response);
                    if (response.success) {
                        $('#fetching').fadeOut();
                        $('#load-more-container').html(response.data.content);
                        page = 2;
                        maxPage = response.data.max_page;
                        canBeLoaded = true;

                        if (filterValue === 'All') {
                            if (maxPage > 1) {
                                $('#load-more-button').text('Load More').show();
                                $('#filter-load-more-button').hide();
                            } else {
                                $('#load-more-button').hide();
                            }
                        } else {
                            if (maxPage > 1) {
                                $('#filter-load-more-button').text('Load More ' + filterValue).show();
                            } else {
                                $('#filter-load-more-button').hide();
                            }
                        }
                    } else {
                        $('#fetching').fadeOut();
                        $('#no-results').fadeIn();
                        canBeLoaded = false;
                        $('#filter-load-more-button').hide();
                        $('#load-more-button').hide();
                        // console.log('No results found for filter');
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX request failed');
                    console.log(textStatus, errorThrown);
                }
            });
        }


        function loadMoreHireItems(filterValue, currentPage) {
            //console.log('Loading more items. Filter: ' + filterValue + ', Page: ' + currentPage);
            $.ajax({
                url: loadmorehireequipment_params.ajaxurl,
                type: 'POST',
                data: {
                    action: 'loadmorehireequipment',
                    page: currentPage,
                    filter: filterValue
                },
                beforeSend: function() {
                    //console.log('Before sending AJAX for load more');
                    // console.log(filterValue);
                    canBeLoaded = false;
                    $('#load-more-button').text('Loading...');
                    $('#filter-load-more-button').text('Loading...');
                },
                success: function(response) {
                    // console.log('Load More AJAX response:', response);
                    if (response.success) {
                        $('#load-more-container').append(response.data.content);
                        page++;
                        canBeLoaded = true;

                        if ( filterValue == 'All' ) {
                            if (page > response.data.max_page) {
                                $('#load-more-button').hide();
                            } else {
                                $('#load-more-button').text('Load More').show();
                            }
                        }
                        else {
                            if (page > response.data.max_page) {
                                $('#filter-load-more-button').hide();
                            } else {
                                $('#filter-load-more-button').text('Load More ' + filterValue).show();
                            }
                        }


                    } else {
                        $('#load-more-button').hide();
                        $('#filter-load-more-button').hide();
                        $('#no-results').fadeIn();
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX request failed');
                    console.log(textStatus, errorThrown);
                }
            });
        }

    }

    if ( $('body').hasClass('tax-equipment-category') ) {
        var canBeLoaded = true;
        var page = parseInt(loadmoretaxequipmentcat_params.current_page) + 1;
        var maxPage = loadmoretaxequipmentcat_params.max_page;
        var currentTermID = $('#termfilter').data('term-value');

        $('#load-more-button').on('click', function() {
            if (!canBeLoaded) {
                return;
            }
            loadMoreTaxEqCatItems(currentTermID, page);
        });

        function loadMoreTaxEqCatItems(filterValue, currentPage) {
            //console.log('Loading more items. Filter: ' + filterValue + ', Page: ' + currentPage);
            $.ajax({
                url: loadmoretaxequipmentcat_params.ajaxurl,
                type: 'POST',
                data: {
                    action: 'loadmoretaxequipmentcat',
                    page: currentPage,
                    filter: filterValue
                },
                beforeSend: function() {
                    //console.log('Before sending AJAX for load more');
                    // console.log(filterValue);
                    canBeLoaded = false;
                    $('#load-more-button').text('Loading...');
                },
                success: function(response) {
                    // console.log('Load More AJAX response:', response);
                    if (response.success) {
                        $('#load-more-container').append(response.data.content);
                        page++;
                        canBeLoaded = true;

                        if (page > response.data.max_page) {
                            $('#load-more-button').hide();
                        } else {
                            $('#load-more-button').text('Load More').show();
                        }


                    } else {
                        $('#load-more-button').hide();
                        $('#filter-load-more-button').hide();
                        $('#no-results').fadeIn();
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('AJAX request failed');
                    console.log(textStatus, errorThrown);
                }
            });
        }
    }

});

